// ABOUTME: Shared type definitions for the Navigation component tree
// ABOUTME: Exports NavigationTabsProps, NavigationSubrouteProps, and internal prop interfaces
import React from "react"

export interface NavigationSubrouteProps {
	label: string
	url: string
	onClick?: (event?: React.MouseEvent<HTMLElement>) => void
	active?: boolean
	subroutes?: NavigationSubrouteProps[]
}

export interface NavigationTabsProps {
	label: string
	url: string
	onClick?: (event?: React.MouseEvent<HTMLElement>) => void
	active?: boolean
	subroutes?: NavigationSubrouteProps[]
}

export const DROPDOWN_CLASSES =
	"bg-container_background rounded-lg shadow-user_menu min-w-[200px]"
